<mat-horizontal-stepper
  labelPosition="bottom"
  [linear]="true"
  #stepper
  style=""
  id="formStepper"
>
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup">
      <ng-template matStepLabel>Contact Details</ng-template>
      <div>
        <h2>Independent Brokers</h2>
        <!-- <p>The online Onboarding application process is intended for independent brokers, regulated by the FCA, that are applying on their own behalf.</p>
        <p style="vertical-align: bottom;font-weight: 600;">Thank You.</p> -->
      </div>
      <div class="ui two column stackable grid">
        <div class="sixteen wide column"><h3>Your Details</h3></div>
        <div class="column">
          <label class="field-label">Full Name</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              name="name"
              (change)="nameUpdate($event)"
              formControlName="fullName"
              required
            />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Position</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              name="position"
              formControlName="position"
              required
            />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Email</label>

          <mat-form-field appearance="outline">
            <input matInput name="email" formControlName="email" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Direct Dial</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              name="telephone"
              formControlName="telephoneDDI"
              required
            />
          </mat-form-field>
        </div>
        <div class="sixteen wide column"><h3>Business Details</h3></div>
        <div class="column">
          <label class="field-label">Name of Firm</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="nameOfFirm" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">FCA Reference Number</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="fcaRefNum" required />
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <label class="field-label">Website URL</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="website" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Head Office Telephone</label>

          <mat-form-field appearance="outline">
            <input
              matInput
              name="telephone"
              formControlName="telephoneHead"
              required
            />
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <h3>Please indicate if you are part of a network</h3>
        </div>
        <div class="sixteen wide column">
          <div
            formArrayName="networkoptions"
            style="display: flex; align-items: center; flex-wrap: wrap"
          >
            @for (option of networkOptions.controls; track option; let i =
            $index) {
            <div [formGroupName]="i" style="padding-right: 10px">
              <mat-checkbox color="primary" [formControlName]="'checked'">{{
                option.get("label").value
              }}</mat-checkbox>
            </div>
            }
          </div>
        </div>
        @if (firstFormGroup.touched &&
        networkOptions.hasError('atLeastOneCheckedError')) {
        <div style="color: red">Please make at least one selection</div>
        }
        <div class="sixteen wide column">
          <h3>UK Company Registered Address</h3>
        </div>
        <div class="column">
          <label class="field-label">Address 1</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="addressOne" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Address 2</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="addressTwo" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Town</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="town" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Postcode</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="postCode" required />
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <h3>How did you hear about us?</h3>
        </div>
        <div class="column">
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="selectedReferal"
              formControlName="referralStream"
              required
            >
              @for (referal of referalOptions; track referal) {
              <option [ngValue]="referal.name">
                {{ referal.name }}
              </option>
              }
            </select>
          </mat-form-field>
          @if (selectedReferal == 'Other') {
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Please Specify"
              formControlName="otherReferal"
            />
          </mat-form-field>
          }
        </div>
      </div>
      <div class="actions">
        <button color="primary" mat-raised-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="secondFormGroup">
    <form [formGroup]="secondFormGroup">
      <ng-template matStepLabel>Company Details</ng-template>
      <div class="ui two column stackable grid">
        <div class="sixteen wide column"><h3>Accounts Contact</h3></div>
        <div class="column">
          <label class="field-label">Full Name</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="accountsFullName" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Position</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="accountsPosition" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Email</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="accountsEmail" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Direct Dial</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              name="telephone"
              formControlName="telephoneDDIAccounts"
              required
            />
          </mat-form-field>
        </div>
      </div>
      <div class="ui two column stackable grid">
        <div class="sixteen wide column"><h3>Agency Manager</h3></div>
        <div class="column">
          <label class="field-label">Full Name</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="agencyFullName" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Position</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="agencyPosition" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Email</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="agencyEmail" required />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Direct Dial</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              name="telephone"
              formControlName="telephoneDDIAgency"
              required
            />
          </mat-form-field>
        </div>
      </div>
      <div class="ui two column stackable grid">
        <div class="sixteen wide column"><h3>Claims Contact</h3></div>
        <div class="column">
          <label class="field-label">Full Name</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="claimsFullName" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Position</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="claimsPosition" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Email</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="claimsEmail" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Direct Dial</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              name="telephone"
              formControlName="telephoneDDIclaims"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="ui two column stackable grid">
        <div class="sixteen wide column"><h3>Marketing Contact</h3></div>
        <div class="column">
          <label class="field-label">Full Name</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="marketFullName" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Position</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="marketPosition" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Email</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="marketEmail" />
          </mat-form-field>
        </div>
        <div class="column">
          <label class="field-label">Direct Dial</label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="telephoneDDImarket" />
          </mat-form-field>
        </div>
      </div>
      <div class="actions">
        <button color="primary" mat-raised-button matStepperPrevious>
          Back
        </button>
        <button color="primary" mat-raised-button matStepperNext>Next</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="thirdFormGroup">
    <form [formGroup]="thirdFormGroup">
      <ng-template matStepLabel>Information</ng-template>

      <div class="ui two column grid">
        <div class="sixteen wide column"><h3>Fair Value</h3></div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Will you apply administration fees to our products? If you will,
            please provide details</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="subBroke"
              formControlName="subBroke"
              required
            >
              @for (works of worksInsuranceOptions; track works) {
              <option [ngValue]="works.name">
                {{ works.name }}
              </option>
              }
            </select>
          </mat-form-field>
          <!-- <mat-form-field appearance="outline" *ngIf="worksInsuranceSelected == 'Yes'">
          <input matInput placeholder="Please Specify" formControlName="approachedDealYes">
        </mat-form-field> -->
        </div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Will you apply administration fees to our products? If you will,
            please provide details</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="adminFee"
              formControlName="adminFeeForm"
              required
            >
              @for (works of worksInsuranceOptions; track works) {
              <option [ngValue]="works.name">
                {{ works.name }}
              </option>
              }
            </select>
          </mat-form-field>
          @if (adminFee == 'Yes') {
          <mat-form-field appearance="outline">
            <input
              id="adminFeeYes"
              matInput
              placeholder="for example – Up to £75 for new business / £25 for any MTA or extension *"
              formControlName="adminFeeYes"
              [required]="adminFee == 'Yes'"
            />
          </mat-form-field>
          }
        </div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Will you apply any add-ons in connection with our products? If you
            will, please provide details</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="addOnsV"
              formControlName="addOns"
              required
            >
              @for (works of worksInsuranceOptions; track works) {
              <option [ngValue]="works.name">
                {{ works.name }}
              </option>
              }
            </select>
          </mat-form-field>
          @if (addOnsV == 'Yes') {
          <mat-form-field appearance="outline">
            <input
              id="addOnsyes"
              matInput
              placeholder="for example – We offer Legal Expenses policies and we may offer premium finance *"
              formControlName="addOnsyes"
              [required]="addOnsV == 'Yes'"
            />
          </mat-form-field>
          }
        </div>
        <div class="sixteen wide column"><h3>Key Information</h3></div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Do you have a private clients and/or commercial construction
            specialism?</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="commercialSelected"
              formControlName="commercialConstructionSpecialism"
              required
            >
              @for (option of commercialOptions; track option) {
              <option [ngValue]="option.name">
                {{ option.name }}
              </option>
              }
            </select>
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Approximately how many mid and high net worth policies do you
            have?</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="networthSelected"
              formControlName="highNetWorthPolicies"
              required
            >
              @for (networth of networthOptions; track networth) {
              <option [ngValue]="networth.name">
                {{ networth.name }}
              </option>
              }
            </select>
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Approximately how many property owners policies do you have?</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="propertyPolicySelected"
              formControlName="propertyOwnerPolicies"
              required
            >
              @for (propertyPolicy of propertyPolicyOptions; track
              propertyPolicy) {
              <option [ngValue]="propertyPolicy.name">
                {{ propertyPolicy.name }}
              </option>
              }
            </select>
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Do you have existing markets for private client and property owners
            contract works insurance?</label
          >
          <mat-form-field appearance="outline">
            <select
              matNativeControl
              [(ngModel)]="worksInsuranceSelected"
              formControlName="approachedDeal"
              required
            >
              @for (works of worksInsuranceOptions; track works) {
              <option [ngValue]="works.name">
                {{ works.name }}
              </option>
              }
            </select>
          </mat-form-field>
          @if (worksInsuranceSelected == 'Yes') {
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Please Specify"
              formControlName="approachedDealYes"
            />
          </mat-form-field>
          }
        </div>
        <div class="sixteen wide column">
          <label class="field-label"
            >Who is the ‘works expert’ in your brokerage?</label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="worksExpert" required />
          </mat-form-field>
        </div>
        <div class="column"></div>
        <div class="sixteen wide column">
          <mat-checkbox color="primary" formControlName="checkboxAgreeCPD"
            >As part of your TOBA Application, we enrol you into our CPD
            programme. Please tick this box to confirm you are happy with this
            process.</mat-checkbox
          >
          <label class="field-label">Brokerage Training Contact</label>
          <mat-form-field
            appearance="outline"
            style="margin-bottom: 1.5rem; margin-top: 0.5rem"
          >
            <input
              matInput
              formControlName="brokerageTrainingContact"
              required
            />
          </mat-form-field>
        </div>
        <div class="sixteen wide column">
          <!-- <mat-form-field appearance="outline">
    <mat-label>Full Name - for signature</mat-label>
    <input #signature (keyup)="sign($event)" matInput placeholder="Full Name - for signature" formControlName="signatureName">
  </mat-form-field> -->
          <!-- <mat-label class="signatureLabel">Signature</mat-label>
  <mat-card class="signatureCard">
    <canvas #sigCanvas id="sigCanvas" width="400" height="60"></canvas>
  </mat-card> -->
          <mat-checkbox color="primary" formControlName="checkboxAgreeSignature"
            >I understand this will be used as my official signature for the
            purposes of this documentation.</mat-checkbox
          >
        </div>
        <div class="sixteen wide column">
          <mat-checkbox color="primary" formControlName="checkboxAgreeTerms"
            >By ticking this box, you confirm that you have read and understood
            the TOBA Document, and agree to receive correspondence, email and
            telephone calls from Renovation Underwriting and
            partners.</mat-checkbox
          >
        </div>
        <i
          >If you have not heard from us within 5 working days, please contact
          us on 0333 358 0006 for an update on your TOBA status.</i
        >
      </div>
      <div class="actions">
        <button mat-raised-button color="primary" matStepperPrevious>
          Back
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!thirdFormGroup.valid || isLoading"
          (click)="submitStep3()"
        >
          Send
        </button>

        @if (isLoading) {
        <div class="loader"></div>
        }
        <div class="error-message">
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
